exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-416c6a7f] tbody td{\n    cursor: pointer;\n}\n[data-v-416c6a7f] tbody td td.non-clickable{\n    cursor: auto;\n}\n.container[data-v-416c6a7f]{\n    max-width: 100vw;\n}\n\n", ""]);

// exports
